import { Component, Input, Output, EventEmitter, OnInit, AfterViewInit } from '@angular/core';

declare interface DataTable {
  headerRow: string[];
  footerRow: string[];
  dataRows: string[][];
}

declare interface Event {
  evento: '';
  id: null;
  row: null;
}

declare var $: any;

@Component({
  selector: 'app-table-select',
  templateUrl: './table-select.component.html',
  styleUrls: ['./table-select.component.css']
})
export class TableSelectComponent implements OnInit, AfterViewInit {

  @Input() table_id: string = 'selectTable';

  @Input() dataTable: DataTable;
  @Input() selectedItems: any;

  @Output() out: EventEmitter<Event>;

  constructor() {
    this.out = new EventEmitter;
  }

  saveEmit(accion, id, row = null) {
    let send;
    send = {
      evento: accion,
      id: id,
      row: row
    };
    this.out.emit(send);
  }

  ngOnInit() {
  }

  agregado(id) {
    let item;
    for (item of this.selectedItems) {
      if (id == item.id) {
        return true;
      }
    }

    return false;
  }

  ngAfterViewInit() {
    $('#' + this.table_id).DataTable({
      'order': [[ 0, 'desc' ]],
       dom: 'lrtip',
      'pagingType': 'full_numbers',
      'lengthMenu': [
        [5, 10, 25, 50, 100, 200, 500, 1000, -1],
        [5, 10, 25, 50, 100, 200, 500, 1000, 'All']
      ],
      responsive: true,
      language: {
        search: '_INPUT_',
        searchPlaceholder: 'Search records',
      }

    });
  }

}
